import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import MultiLineChartCard from 'components/DetailWidgets/MultiLineChartCard';
import Actions from './Actions';
import Header from './Header';

const LOYALTY_SERIES = [
  { key: 'total_customers', labelKey: 'overview.total_customers', color: '#181C21' },
  { key: 'returning_customers', labelKey: 'overview.returning_customers', color: '#1976D2' },
  { key: 'new_customers', labelKey: 'overview.new_customers', color: '#DCA815' },
  { key: 'lost_customers', labelKey: 'overview.lost_customers', color: '#FF3B30' }
];

function toPoints(x = [], y = []) {
  return x.map((label, index) => ({ label, value: Number(String(y[index]).replaceAll(',', '')) || 0 }));
}

export default withTranslation()(function Chart({ t }) {
  const [dataView, setDataView] = useState('general')
  const [chartData, setChartData] = useState([])
  const [tab, setTab] = useState('revenue')

  const createXY = (data) => ({
    x: data?.map((entry) => Object.keys(entry)[0]) ?? [],
    y: data?.map((entry) => Object.values(entry)[0]) ?? []
  })

  const getChartData = (params) => {
    const data = params?.graph_data
    if (!data) return setChartData([])
    if (!data.total_customers) return setChartData([createXY(data)])
    setChartData(Object.values(data).map(createXY))
  }

  const tabs = [
    { key: 'revenue', label: t('overview.tabs.revenue') },
    { key: 'loyalty', label: t('overview.tabs.loyalty') },
    { key: 'review', label: t('overview.tabs.review') }
  ]

  const series = tab === 'loyalty'
    ? LOYALTY_SERIES.map((line, index) => ({
      key: line.key,
      label: t(line.labelKey),
      color: line.color,
      data: toPoints(chartData?.[0]?.x, chartData?.[index]?.y)
    }))
    : [{
      key: tab,
      label: tabs.find((current) => current.key === tab)?.label,
      color: '#1976D2',
      data: toPoints(chartData?.[0]?.x, chartData?.[0]?.y)
    }]

  return (
    <div className="w-full flex flex-col gap-3">
      <div className="lg:flex xs:flex-col w-full justify-between">
        <Actions dataView={dataView} setView={setDataView} />
        <Header dataView={dataView} getChartData={getChartData} tab={tabs.findIndex((current) => current.key === tab)} />
      </div>

      <MultiLineChartCard
        title={t('overview.performance_overview')}
        tabs={tabs}
        activeTab={tab}
        onTabChange={setTab}
        series={series}
      />
    </div>
  )
});
